import { FC } from 'react';
import { useSelector } from 'react-redux';

import clsx from 'clsx';
import { ParkingPlace } from 'src/components/ParkingPlace/ParkingPlace';
import { getAdminState } from 'src/store/admin/selectors';
import { Parking } from 'src/types';

import classes from './AdministratorParkingPlace.module.scss';

export interface AdministratorParkingPlaceProps {
  item: Parking;
}

export const AdministratorParkingPlace: FC<AdministratorParkingPlaceProps> = ({
  item,
}) => {
  const { selectedPlace, ghost } = useSelector(getAdminState);

  const active = selectedPlace?.mapPlaceId === item.mapPlaceId;

  const disabled = ghost?.mapPlaceId === item.mapPlaceId;

  return (
    <ParkingPlace
      item={item}
      className={clsx(classes.container, active && classes.active)}
      contentClassName={clsx(classes.title, active && classes.titleActive)}
      disabled={disabled}
    />
  );
};
